import React from 'react';

const TermsValueTwo = () => {
  return (
    <div className="term-value-card">
      <div className="title">
        <h5>73.07 billion</h5>
        <h4>tonnes</h4>
        <p>Iron ore reserves</p>
        
      </div>
    </div>
  );
};

export default TermsValueTwo;
